export const LOCAL_NOTES_NAME = "localNotes";
